
export default {
    assembleInstalments
}

function assembleInstalments(response) {
    let installments = [];

    if (response.data && response.data.currency && Array.isArray(response.data.currency.plans)) {
        installments = response.data.currency.plans.map(plan => ({
            installmentNumber: plan.installmentNumber,
            installments: plan.installments,
            interestsInstallment: plan.interests,
            total: plan.total
        }));
    } else {
        console.error("Invalid response structure:", response);
    }

    return installments;
}


// WEBPACK FOOTER //
// ./src/services/installments/InstallmentsToInstallmentsModelAssembler.js